import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Divider, LinearProgress, Typography, useTheme } from '@mui/material';

import { LayoutBase } from '../../../../../layouts';
import { AccordionInstruments, ToolsDamInformation } from '../../../../../components/custom';
import { VMenu } from '../../../../../components/shared';
import { IReadingsInstruments, ReadingServices } from '../../../../../services/api/reading/ReadingServices';

type ApiResponseItem = IReadingsInstruments | string | null;

export const Kpi = () => {
    const { id } = useParams();
    const theme = useTheme();

    const [dataFromBackend, setDataFromBackend] = useState<ApiResponseItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = () => {
        setIsLoading(true);
        if (id !== undefined) {
            ReadingServices.getAll(id)
                .then((response) => {
                    if (response instanceof Error) {
                        console.error(response.message);
                        setDataFromBackend([]);
                    } else {
                        setDataFromBackend(response as ApiResponseItem[]); 
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setDataFromBackend([]);
            setIsLoading(false);
        }
    };

    const getInstrumentsData = (data: ApiResponseItem[]): IReadingsInstruments[] => {
        return data.filter((item): item is IReadingsInstruments =>
            item !== null && typeof item === 'object' && 'tipo_instrumento' in item
        );
    };

    function ValuesByInstrument(instruments: IReadingsInstruments[], type: string): IReadingsInstruments[] {
        if (!Array.isArray(instruments) || instruments.length === 0) {
            return [];
        }
        const filtered = instruments.filter(instrument => instrument.tipo_instrumento === type);
        return filtered;
    }

    const getNPGBValue = (data: ApiResponseItem[]): string => {
        const npgbValueRaw = data[data.length - 1];

        if (npgbValueRaw === null) {
            return 'Inexistente';
        } else if (typeof npgbValueRaw === 'string') {
            return npgbValueRaw;
        } else {
            return 'N/A (Formato inesperado para NPGB)';
        }
    };

    const instrumentsList = getInstrumentsData(dataFromBackend);

    const npgbDisplayValue = getNPGBValue(dataFromBackend);

    return (
        <LayoutBase
            title='Kpis'
            tollBar={
                <ToolsDamInformation />
            }
        >
            <Box width={'100%'}>
                <VMenu id={id} />
                <Typography variant='h6' color={theme.palette.primary.main}>KPI`s</Typography>
                <Divider flexItem orientation='horizontal' />
                <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} marginTop={1} gap={1} padding={1}>
                    <Box padding={2} display={'flex'} flexDirection={'column'} gap={2}>
                        {isLoading ? (
                            <LinearProgress />
                        ) : (
                            <>
                                <Typography>
                                    Nível de Perigo Global da Barragem – NPGB: &nbsp;
                                    <Typography
                                        component="span"
                                        variant='h6'
                                    >
                                        {npgbDisplayValue}
                                    </Typography>
                                </Typography>

                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'piezometro')}
                                    type='Piezômetro'
																		titulo='Piezômetro'
                                />
                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'indicador')}
                                    // eslint-disable-next-line quotes
                                    type={"Indicador NA"}
																		titulo='Indicador NA'
                                />
                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'pluviometro')}
                                    type='Pluviômetro'
																		titulo='Pluviômetro'
                                />
                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'regua')}
                                    type='Régua'
																		titulo='Régua'
                                />
                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 're')}
                                    type='Ré'
																		titulo='Ré Topografica'
                                />
                                <AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'marco')}
                                    type='Marco'
																		titulo='Marco'
                                />
																<AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'vazao')}
                                    type='vazao'
																		titulo='Medidor de Vazão'
                                />
																<AccordionInstruments
                                    data={ValuesByInstrument(instrumentsList, 'inclinometro')}
                                    type='inclinometro'
																		titulo='Inclinômetro'
                                />
                            </>
                        )}
                    </Box>
                </Box>
            </Box>
        </LayoutBase>
    );
};